import { when } from '@execonline-inc/maybe-adapter';
import { ProductLicenseResource } from '../../../../../../Types';
import { CustomizeState, Visibility } from '../../../../Store/Types';
import { equals } from '@execonline-inc/collections';

const whenShowProductLicenseChangeDialog = (productLicenseChangeDialog: Visibility) => () =>
  when(equals(productLicenseChangeDialog, 'show'), {});

const whenNoMatchingProductIds =
  (activeProductLicense: ProductLicenseResource) =>
  (selectedProductLicense: ProductLicenseResource) =>
    when(
      selectedProductLicense.payload.id !== activeProductLicense.payload.id,
      selectedProductLicense,
    );

export const warnUser = (state: CustomizeState, activeProductLicense: ProductLicenseResource) => {
  return state.selectedProductLicense
    .andThen(whenNoMatchingProductIds(activeProductLicense))
    .andThen(whenShowProductLicenseChangeDialog(state.productLicenseChangeDialog));
};
